import { FC } from 'react';

import { CartLineItem } from '@/types';

import { CartBodyItem } from './CartBodyItem';

import style from './cartnavigation.module.scss';

interface CartBodyProps {
  products: CartLineItem[];
}

const CartBody: FC<CartBodyProps> = ({ products }) => (
  <ul className={style.cart__body_container}>
    {products?.map((product, index) => (
      <CartBodyItem key={product?.id || index} product={product} />
    ))}
  </ul>
);

export default CartBody;
